import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { Product, WorkOrder } from '@newmoon-org/types';

import ProductBrowser from './ProductBrowser.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkOrderMaintenanceProduct',
  props: {
    workOrder: null,
    isReadOnly: { type: Boolean }
  },
  emits: ["onMaintenanceRequired", "onMaintenanceFrequency", "onProductChange"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'onMaintenanceRequired', value: { isMaintenanceRequired: boolean }): void;
  (event: 'onMaintenanceFrequency', value: { maintenanceFrequency: number }): void;
  (event: 'onProductChange', value: { products: Product[] }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  workOrder: WorkOrder;
  isReadOnly?: false;
}





const MaintenanceFrequencies = [3, 6, 12, 18, 24] as const;
const maintenanceFrequencies = ref<typeof MaintenanceFrequencies>(MaintenanceFrequencies);
const isMaintenanceRequired = ref<boolean>(props.workOrder.isMaintenanceRequired ?? false);
const maintenanceFrequency = ref<number>(props.workOrder.maintenanceFrequency ?? 3);
const requiredMaintenanceProducts = ref<Product[]>(props.workOrder?.maintenanceRequiredProducts ?? []);

watch(isMaintenanceRequired, () =>
  emit('onMaintenanceRequired', { isMaintenanceRequired: isMaintenanceRequired.value })
);

watch(maintenanceFrequency, () => emit('onMaintenanceFrequency', { maintenanceFrequency: maintenanceFrequency.value }));

const canHaveMoreProducts = computed<boolean>(() => {
  return requiredMaintenanceProducts.value.length < 3;
});

function requiredMaintenanceProductAdd(product: Product): void {
  requiredMaintenanceProducts.value.push(product);
  emit('onProductChange', { products: requiredMaintenanceProducts.value });
}

function removeRequiredMaintenceProduct(productId: string): void {
  requiredMaintenanceProducts.value = requiredMaintenanceProducts.value.filter(p => p.id !== productId);
  emit('onProductChange', { products: requiredMaintenanceProducts.value });
}

return { __sfc: true,props, emit, MaintenanceFrequencies, maintenanceFrequencies, isMaintenanceRequired, maintenanceFrequency, requiredMaintenanceProducts, canHaveMoreProducts, requiredMaintenanceProductAdd, removeRequiredMaintenceProduct, ProductBrowser }
}

})